import Dream from '../dream';

/**
 * Create the action
 */

const { thunk, request, success, error } = Dream.show((id, fetch) =>
  fetch.get(`/dreams/dream/${id}`)
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
